import $ from 'jquery';
import { ClosedCaptionManager } from '../ClosedCaptionManager';
import SoundProps from '../Misc/SoundProps';
import Tools from '../Misc/Tools';
/**
 * Manager for sound
 */
export default class SoundManager {

	public onForceUpdate: () => void

	/**
	 * All active sounds. These are the sounds that get added to the DOM
	 */
	public activeSounds: ActiveSound[] = [];

	public ccManager: ClosedCaptionManager = new ClosedCaptionManager();

	/**
	 * The audio context to mix and play sounds
	 */
	private _audioContext: any;

	/**
	 * True to hide caption
	 */
	public static hiddenCaption: boolean = false;

	/**
	 * True to mute audio
	 */
	private _mutedAudio: boolean = false;
	public set mutedAudio(value: boolean) {
		this._mutedAudio = value;
		if(this._mutedAudio) {
			this.muteAllSound();
		} else {
			this.unmuteAllSound();
		}
	}

	constructor() {
		var context = this;
		$(document).ready(function(){
			console.log('init entered');
			var audioContext = null;
			try {
				window.AudioContext = new (window.AudioContext||(window as any).webkitAudioContext)();
				audioContext = window.AudioContext;
				console.log('audio api initialized');
			}
			catch(e) {
				console.error('Web Audio API is not supported in this browser');
			}

			context._audioContext = audioContext;
		});
	}

	/**
	 * Downloads and plays a sound
	 * @param sound The sound property to play
	 * @param onGetSoundId Optional: Called when the audio is played. The purpose of this callback is for the caller to be able to retain the ID of the sound in case it is needed for future operations on this specific sound
	 */
	public playSound(sound: SoundProps, onGetSoundId?: (id: string) => void): void {
		// if(Globals.skipAnimations) {
		// 	if(sound.onEnded) {
		// 		sound.onEnded();
		// 	}

		// 	return;
		// }
		var context = this;
		var request = new XMLHttpRequest();
		request.open('GET', sound.src, true);
		request.responseType = 'arraybuffer';
        var onError = (err: any) => {
			console.error(err);
		}
		request.onload = function() {
			context._audioContext.decodeAudioData(request.response, (buffer: any) => {
				var id = context._playRawSound(sound, buffer);

				if(onGetSoundId) {
					onGetSoundId(id);
				}
			}, onError);
		}
          
		request.send();
	}

	/**
	 * Changes the pitch on a particular sounce. +100 and -100 detune the source up or down by one semitone, while +1200 and -1200 detune it up or down by one octave
	 */
	 public changePitch(soundId: string, pitch: number): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			if(this.activeSounds[indx].id === soundId) {
				this.activeSounds[indx].audioContextSource.detune.value = pitch;
				break;
			}
		}
	}

	/**
	 * Stops a particular sound
	 */
	public stopSound(soundId: string): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			if(this.activeSounds[indx].id === soundId) {
				this.activeSounds[indx].audioContextSource.stop();
				this.activeSounds.splice(indx);
				break;
			}
		}
	}

	/**
	 * Pauses a particular sound
	 */
	public pauseSound(soundId: string): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			if(this.activeSounds[indx].id === soundId) {
				this.activeSounds[indx].audioContextSource.suspend();
				this.activeSounds[indx].isPaused = true;
				break;
			}
		}
	}

	/**
	 * Mutes all sounds
	 */
	 public muteAllSound(): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			this.activeSounds[indx].audioContextSource.gainNode.gain.value = 0;
		}
	}

	/**
	 * Unmutes all sounds
	 */
	 public unmuteAllSound(): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			this.activeSounds[indx].audioContextSource.gainNode.gain.value = 1;
		}
	}

	/**
	 * Pauses all sounds
	 */
	public pauseAllSound(): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			this.activeSounds[indx].audioContextSource.suspend();
			this.activeSounds[indx].isPaused = true;
		}
	}

	/**
	 * Resumes a currently paused sound
	 */
	public resumeSound(soundId: string): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			if(this.activeSounds[indx].id === soundId) {
				this.activeSounds[indx].audioContextSource.resume();
				this.activeSounds[indx].isPaused = false;
				break;
			}
		}
	}

	/**
	 * Resumes all sounds
	 */
	public resumeAllSound(): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			this.activeSounds[indx].audioContextSource.resume();
			this.activeSounds[indx].isPaused = false;
		}
	}

	/**
	 * Stops all currently playing sounds
	 */
	public stopAllSounds(): void {
		this.ccManager.stopAll();

    	for(var indx2 = this.activeSounds.length - 1; indx2 >= 0; indx2--) {
			this.activeSounds[indx2].audioContextSource.stop();
			this.activeSounds.splice(indx2);
			// SoundManager.currentCaption = null;
		}
	}

	/**
	 * Plays the sound and displays captions (assumes the sound has already been downloaded)
	 */
	 private _playRawSound(sound: SoundProps, buffer: any) {
		var context = this;
		var id = Tools.generateGuid();
		(sound as any).id = id;
		(sound as any).soundManager = this;
		var props = {...sound};
		props.onEnded = () => {
			if(props.oneShot) {
				context.stopSound(id);
			}
			
			if(sound.onEnded) { 
				sound.onEnded();
			}
		};


		var activeSound: ActiveSound = {
			id: id,
			audioContextSource: null
			// currentCaption: null,
		};

		if (props.enableClosedCaptioning) {
			var vttPath = props.src.slice(0, -3) + "vtt";
			this.ccManager.loadVtt(vttPath, id, context.onForceUpdate);
		}
		
		activeSound.audioContextSource = this._audioContext.createBufferSource();
		activeSound.audioContextSource.gainNode = this._audioContext.createGain();
		activeSound.audioContextSource.buffer = buffer; 

		if(typeof sound.volume !== 'undefined') {
			activeSound.audioContextSource.gainNode.gain.value = sound.volume; 
		}

		if(typeof sound.pitch !== 'undefined') {
			activeSound.audioContextSource.detune.value = sound.pitch; 
		}

		if(sound.loop) {
			activeSound.audioContextSource.loop = sound.loop;
		}
		
		// activeSound.audioContextSource.connect(this._audioContext.destination); 
		activeSound.audioContextSource.connect(activeSound.audioContextSource.gainNode);
		activeSound.audioContextSource.gainNode.connect(this._audioContext.destination); 

		activeSound.audioContextSource.onended = () => {
			props.onEnded();
		};
		if(sound.muted) {
			activeSound.audioContextSource.gainNode.gain.value = 0;
		}
		activeSound.audioContextSource.start(0);

		context.activeSounds.push(activeSound);
		return id;
	}
}

/**
 * Describes an active sound in the page
 */
export interface ActiveSound {
	/**
	 * The id of the sound. This should match the ID attribute in the DOM
	 */
	id: string;

	/**
	 * The audio context for audio mixing and playback
	 */
	audioContextSource: any;

	/**
	 * True if this sound has been paused
	 */
	isPaused?: boolean;

	/**
	 * The current caption associated with this sound
	 */
	currentCaption?: string;
}
